import React from "react"
import { useStaticQuery, graphql } from "gatsby"

let tokCache

export const Provider = () => {
  const gql = graphql`
    query {
      cliCommands: allCliCommandsJson(sort: { fields: slug, order: ASC }) {
        nodes {
          path: gatsbyPath(filePath: "/reference/cli/{cliCommandsJson.slug}")
          title
        }
      }
    }
  `
  return useStaticQuery(gql).cliCommands.nodes.reduce((out, c) => {
    out[c.title] = { name: c.title, path: c.path }
    return out
  }, {})
}

export default ({ query, render }) => {
  let token

  if (typeof query === "string") {
    if (!tokCache) {
      tokCache = Provider()
    }
    token = tokCache[query.replace(/\(\)$/, "")]
  }

  return <>{render(token || null)}</>
}
